<template>
    <el-col :xs="{span:24}" :md="width" v-show="show">
        <!-- <el-form-item
            :class="className"
            :label="displayName" 
            :prop="name"
            :rules="rules">
            <textarea :name="fieldName" :value="data[name]" hidden="hidden"></textarea>
        </el-form-item> -->
        <input :name="fieldName" :value="data[name]" hidden="hidden">
        <input :name="contentType + '.' + name + '.ContentType'" :value="requestContentType" hidden="hidden">
        <qweForm 
            data-name="hasOneFieldForm"
            :htmlPrefix = "name"
            :showButton="false"
            class="hasOneFieldForm"
            @operatorForm="formSubmit"
            @initForm ="initForm"
            :operation="requestOperation"
            :content-type="requestContentType"
            :content-item-id="data[name]">
            </qweForm>
    </el-col>
</template>

<script>
    import { qweIsEmpty } from "../../../common/commonHelper";
    import qweBaseField from "../BaseField"
    import form from "../../Form/FormItem.vue"

    export default {
        mixins:[qweBaseField],
        name:"HasOneField",
        components:{
            "qweForm":form
        },
        data:function(){
            return {
                requestContentType:"",
            }
        },
        created:function(){
            let function1 = new Function("Context", "Content", "self", "setContentType", this.selfSetting.ContentType); 
            let context = this.buildFormContext();
            function1(context, this.data, this, this.setContentType);
            if(this.selfSetting.RelyFields.length > 0){
                (this.selfSetting.RelyFields || []).forEach(x => {
                    this.$watch("data." + x, function (newVal, oldVal) {
                        let context = this.buildFormContext();
                        function1(context, this.data, this, this.setContentType);
                    })
                });
            }
        },
        computed:{
            requestOperation:function(){
                return qweIsEmpty(this.data[this.name]) ? "Create" : "Edit"
            }
        },
        methods:{
            formSubmit:function(contentItemId){
                //this.data[this.name] = contentItemId;
            },
            initForm:function(contentItemId){
                //this.requestContentItemId = contentItemId;
            },

            setContentType:function(contentType){
                this.requestContentType = contentType;
            }
        }
    }
</script>